import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 31 31" {...props}>
      <path d="M30.1935 13.5957L17.2656 0.667791C16.456 -0.141868 15.1456 -0.141868 14.3413 0.667791L1.40803 13.5957C0.598366 14.4054 0.598366 15.7157 1.40803 16.5201L14.3413 29.4533C15.1456 30.263 16.456 30.263 17.2656 29.4533L30.1935 16.5201C31.0032 15.7157 31.0032 14.4054 30.1935 13.5957ZM16.4826 21.8787H15.119C14.7408 21.8787 14.4371 21.5751 14.4371 21.1969V19.8333C14.4371 19.4551 14.7408 19.1515 15.119 19.1515H16.4826C16.8608 19.1515 17.1644 19.4551 17.1644 19.8333V21.1969C17.1644 21.5751 16.8608 21.8787 16.4826 21.8787ZM15.8008 16.4242C15.0497 16.4242 14.4371 15.8116 14.4371 15.0605V9.606C14.4371 8.85494 15.0497 8.24236 15.8008 8.24236C16.5518 8.24236 17.1644 8.85494 17.1644 9.606V15.0605C17.1644 15.8116 16.5518 16.4242 15.8008 16.4242Z" />
    </Svg>
  )
}

export default Icon
